import { render, staticRenderFns } from "./NextPriceDrop.vue?vue&type=template&id=4cd1c4ae&"
import script from "./NextPriceDrop.vue?vue&type=script&lang=js&"
export * from "./NextPriceDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports